import { render, staticRenderFns } from "./veJkyMeetPlace.vue?vue&type=template&id=6df0644c&scoped=true"
import script from "./veJkyMeetPlace.vue?vue&type=script&lang=js"
export * from "./veJkyMeetPlace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df0644c",
  null
  
)

export default component.exports